import { PermissionNames } from '../types/account.types';
import { RightElement, SettingsParentPage } from './header.types';

export const NAVIGATION_ITEMS = [
  {
    isInternal: true,
    url: '/',
    name: 'Market',
  },
  {
    url: 'https://locavoredelivery.com/how-it-works/',
    name: 'How it works',
    submenu: [
      {
        url: 'https://locavoredelivery.com/how-it-works/',
        name: 'How it works',
      },
      {
        url: 'https://locavoredelivery.com/delivery-map/',
        name: 'Delivery Map',
      },
    ],
  },
  {
    url: 'https://market.locavoredelivery.com/summary.php?go=products&cat=44&12',
    name: 'Learn',
    submenu: [
      {
        isInternal: true,
        url: '/pages/producers',
        name: 'Foodshed Partners',
      },
      {
        url: 'https://locavoredelivery.com/locavore-delivery-sourcing-standards/',
        name: 'Our Sourcing Standards',
      },
      {
        url: 'https://locavoredelivery.com/about-us/',
        name: 'About us',
      },
      {
        url: 'https://locavoredelivery.com/blog/',
        name: 'Recipes + Tips + Farm News',
      },
    ],
  },
  {
    url: 'https://locavoredelivery.com/contact/',
    name: 'Contact Us',
  },
  {
    isInternal: true,
    url: '/pages/gift-cards',
    name: 'Gift Cards',
  },
];

export const SETTINGS_PAGES: SettingsParentPage[] = [
  {
    icon: 'account_circle',
    name: 'Account settings',
    children: [
      {
        route: '/settings/account/profile',
        name: 'Profile',
        permissionName: PermissionNames.settingsProfile,
      },
      {
        route: '/settings/account/subscriptions',
        name: 'Subscriptions',
        permissionName: PermissionNames.settingsSubscription,
      },
      {
        route: '/settings/account/deliveries',
        name: 'Deliveries',
        name2: 'Pick-Ups',
        permissionName: PermissionNames.settingsDeliveries,
      },
      {
        route: '/settings/account/friend-referrals',
        name: 'Friend Referrals',
        permissionName: PermissionNames.settingsFriednReferrals,
      },
    ],
    permissionName: PermissionNames.settings,
  },
  {
    icon: 'credit_card',
    name: 'Billing settings',
    children: [
      {
        route: '/settings/billing/membership',
        name: 'Membership',
        permissionName: PermissionNames.settingsMemebership,
      },
      {
        route: '/settings/billing/order-and-billing',
        name: 'Order & Billing',
        permissionName: PermissionNames.settingsOrderHistory,
      },
      {
        route: '/settings/billing/invoice-history',
        name: 'Invoice History',
        permissionName: PermissionNames.settingsInvoiceHistory,
      },
    ],
    permissionName: PermissionNames.settings,
  },
];

export const RIGHT_ELEMENTS: RightElement[] = [
  {
    tooltip: 'Favorites',
    route: '/favorites',
    icon: 'favorite',
    permissionName: PermissionNames.shop,
  },
  {
    tooltip: 'Buy Again',
    route: '/buy-again',
    icon: 'verified',
    permissionName: PermissionNames.shop,
  },
  {
    tooltip: 'Cart',
    route: '/order',
    icon: 'shopping_cart',
    showBadge: true,
    permissionName: PermissionNames.order,
    showWithoutPermission: true,
  },
];
